import { Lightbox } from "../lightbox";
import { FileInspectorInlineItem } from "./file-inspector-inline-item";
import type { FileInspectorProps } from "./shared";

export function FileInspectorInline<T extends { id: string }>({
	itemFiles,
	useRemoteFileUrl,
	getAnnotations,
	onSaveAnnotations,
	annotatedFileIds,
}: Omit<FileInspectorProps<T>, "variant" | "renderFile" | "size">) {
	/** Type Guard */
	if (!useRemoteFileUrl) return null;

	/** Render */
	return (
		<Lightbox.Provider itemHeight="40px">
			<div className="flex flex-col pt-1">
				<Lightbox.Container>
					{itemFiles.map(({ file }) => (
						<FileInspectorInlineItem
							key={file.id}
							file={file}
							useRemoteFileUrl={useRemoteFileUrl}
							getAnnotations={getAnnotations}
							onSaveAnnotations={onSaveAnnotations}
							hasAnnotations={annotatedFileIds?.has(file.id)}
						/>
					))}
				</Lightbox.Container>
			</div>
		</Lightbox.Provider>
	);
}
